import MuiInputAdornment, { InputAdornmentProps as MuiInputAdornmentProps } from '@mui/material/InputAdornment';
import * as React from 'react';

interface InputAdornmentProps extends MuiInputAdornmentProps {}

export const InputAdornment = (props: InputAdornmentProps) => {
  return <MuiInputAdornment {...props} />;
};
